export function formatPrice(price: number | string) {
  if (price == null) return '';
  const num = typeof price === 'string' ? Number(price) : price;
  if (Number.isNaN(num)) return '';
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
